export default __webpack_public_path__ + "static/bitcoin_cash-2acd4bda8785745cddba8a5d40219751.png";